import Banner from "../components/Banner";
import Categories from "../components/Categories";
import Resources from "../components/Resources";
import Contact from "../components/Contact";
import '../assets/Home.css';

export default function Home({items}) {
  
  return (
    <div id="home">
      <Banner />
      <Categories items={items} />
      <Resources />
      <Contact name="META Solutions" href="https://www.metasolutions.net/"/>
  </div>
  );
}
